import { categories } from "@redotech/redo-model/advanced-flow/triggers";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const createDefaultFlowsAndTemplates = {
  name: "createDefaultFlowsAndTemplates" as const,
  input: z.object({
    teamId: z.string(),
    category: createEnum(categories),
    sourceTeamId: z.string().optional(),
  }),
  output: z.object({
    templates: z.array(z.string()),
    flows: z.array(z.string()),
  }),
};
